import { RestaurantResponseType } from '../restaurant/restaurant.types';
import { BaseResponseType } from '../cognito/authResponse.types';

export enum PayrollPayPeriod {
  WEEKLY = 'WEEKLY',
  BI_WEEKLY = 'BI_WEEKLY',
  MONTHLY = 'MONTHLY',
}
export interface CreatePayrollType {
  payPeriod: PayrollPayPeriod;
  restaurantId: number;
}
export interface PayrollType {
  id: number;
  payPeriod: PayrollPayPeriod;
  restaurant: RestaurantResponseType;
}
export interface EmployeePayroll {
  payData: any[];
  employeeMeta: any;
}
export interface GetPayrollsResponseType extends BaseResponseType {
  data: PayrollType | null;
}
export interface CreatePayrollResponseType extends BaseResponseType {
  data: PayrollType | null;
}
export interface DeletePayrollResponseType extends BaseResponseType {
  data: null;
}
